import {getEventId} from '@wix/wix-events-commons-statics'
import {membersPageDataHooks as DH} from '@wix/wix-events-data-hooks'
import {useTranslation} from '@wix/yoshi-flow-editor'
import React from 'react'
import {useMembersPageActions, useMembersPageSelector} from '../../../hooks/runtime'
import {isTicketedWithNoOrder} from '../../../selectors/event'
import {getEventTickets} from '../../../selectors/tickets'
import {downloadTickets, downloadTicketsWithNoOrder} from '../../../services/tickets'
import {EventLink} from '../../styled-components/event-link'
import {MobileDownloadTicketsButtonProps} from './interfaces'

export const MobileDownloadTicketsButton = ({event, order}: MobileDownloadTicketsButtonProps) => {
  const {t} = useTranslation()

  const eventId = getEventId(event.event)
  const ticketedWithNoOrder = isTicketedWithNoOrder(event)
  const eventTickets = useMembersPageSelector(state => getEventTickets(state, eventId))

  const {downloadTicketsAction} = useMembersPageActions()

  const handleEventLinkClick = () => {
    ticketedWithNoOrder ? downloadTicketsWithNoOrder(eventTickets) : downloadTickets(order)

    downloadTicketsAction(eventId)
  }

  return (
    <EventLink
      secondary={true}
      mobile={true}
      onClick={handleEventLinkClick}
      data-hook={DH.MOBILE_BUTTON_DOWNLOAD_TICKETS}
    >
      {t('events.buttons.download-tickets')}
    </EventLink>
  )
}
